// @ts-nocheck
import { PreferencesCreditNotesBoot } from './PreferencesCreditNotesFormBoot';
import { PreferencesCreditNotesFormPage } from './PreferencesCreditNotesFormPage';

/**
 * Credit notes preferences.
 */
export function PreferencesCreditNotes() {
  return (
    <PreferencesCreditNotesBoot>
      <PreferencesCreditNotesFormPage />
    </PreferencesCreditNotesBoot>
  );
}
